module.exports = __webpack_public_path__ + "img/portrait-041.81919d96.jpg";